import { FaRoad, FaGasPump } from "react-icons/fa";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { TbRoute2 } from "react-icons/tb";
import InputField from "../../InputField";
import styles from "./CarInitialInfo.module.css";



const CarInitialInfo = ({ formik }) => {

  const {

    values,

    errors,

    touched,

    handleChange,

    handleBlur,

}=formik;

  return (
    <section className={styles.card}>

      <div className={styles.header}>
        <h3>⚙️ اطلاعات اولیه</h3>

        <p>
          این اطلاعات برای محاسبه زمان سرویس‌ها و هزینه‌های خودرو استفاده
          می‌شود.
        </p>
      </div>

      <InputField
        id="kilometer"
        name="kilometer"
        label="کیلومتر فعلی"
        icon={<FaRoad />}
        value={values.kilometer}
        placeholder="مثلاً 125000"
        inputMode="numeric"
        format="number"
        suffix="کیلومتر"
        required
        error={errors.kilometer}
        touched={touched.kilometer}
        onChange={handleChange}
        onBlur={handleBlur}
        hint="کیلومتر فعلی خودرو"
      />

      <InputField
        id="productYear"
        name="productYear"
        label="سال ساخت"
        icon={<MdOutlineCalendarMonth />}
        value={values.productYear}
        placeholder="مثلاً 1401"
        inputMode="numeric"
        format="number"
        required
        error={errors.productYear}
        touched={touched.productYear}
        onChange={handleChange}
        onBlur={handleBlur}
      />

      <InputField
        id="distancePerWeek"
        name="distancePerWeek"
        label="میانگین حرکت هفتگی"
        icon={<TbRoute2 />}
        value={values.distancePerWeek}
        placeholder="مثلاً 350"
        inputMode="numeric"
        format="number"
        suffix="کیلومتر"
        required
        error={errors.distancePerWeek}
        touched={touched.distancePerWeek}
        onChange={handleChange}
        onBlur={handleBlur}
        hint="میانگین مسافت طی شده در یک هفته"
      />

      <InputField
        id="useFuel"
        name="useFuel"
        label="مصرف سوخت"
        icon={<FaGasPump />}
        value={values.useFuel}
        placeholder="مثلاً 8"
        inputMode="numeric"
        format="number"
        suffix="لیتر / 100km"
        required
        error={errors.useFuel}
        touched={touched.useFuel}
        onChange={handleChange}
        onBlur={handleBlur}
        hint="مصرف سوخت در هر ۱۰۰ کیلومتر"
      />

    </section>
  );
};

export default CarInitialInfo;